import { Inject } from 'inversify-props'
import type { WebhookServiceAdapter } from './adapter'
import { FormWebhook, Webhook } from '@/models'

export class SaveWebhookUseCase {
	@Inject('WebhookServiceAdapter')
	private webhookService!: WebhookServiceAdapter

	create = async (webhook: FormWebhook): Promise<Webhook> =>
		await this.webhookService.create(webhook)

	update = async (webhook: FormWebhook): Promise<Webhook> =>
		await this.webhookService.update(webhook)
}
